<template>
  <div class="mt-10">
    <div class="mb-4">
      <h3 class="fsize32 text-primary font-semibold mb-2">Financial Support</h3>
      <p class="fsize14">
        Cancer treatment can be expensive, and as a caregiver, you may be
        concerned about the financial burden it may place on the patient and
        their family. In this blog, we will discuss the financial support
        available to cancer patients and their caregivers.
      </p>
    </div>
    <div class="flex w-full gap-6">
      <div class="container">
        <div class="w-full flex items-center gap-6 mt-8">
          <div class="w-1/2">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/cancer-page/The-cost-of-cancer-treatment.jpg"
              alt="cancer"
              class="section_img1 object-cover"
            />
          </div>
          <div class="w-1/2">
            <h2 class="fsize20 font-bold text4F0A4B uppercase">
              The cost of cancer treatment:
            </h2>
            <p class="fsize14">
              Cancer treatment costs can vary widely depending on the type of
              cancer, stage, and treatment options. Some common cancer
              treatments include surgery, radiation therapy, chemotherapy,
              immunotherapy, and targeted therapy. These treatments can be
              expensive, and the cost may not be covered entirely by insurance. 
            </p>
          </div>
        </div>

        <div class="mt-12">
          <div class="w-full">
            <h2
              class="fsize20 text4F0A4B text-left mb-1 uppercase font-semibold"
            >
              Financial support options:
            </h2>
          </div>
          <div class="w-full grid grid-cols-3 gap-4 mt-5">
            <div class="cust-option-sections">
              <h2
                class="fsize16 text4F0A4B text-center uppercase font-semibold"
              >
                Non-profit organizations
              </h2>
              <p class="fsize13 mt-2 text-center">
                Several non-profit organizations provide financial assistance to
                cancer patients and their families. These organizations can help
                cover the cost of treatment, transportation, and other
                expenses. 
              </p>
            </div>
            <div class="cust-option-sections">
              <h2
                class="fsize16 text4F0A4B text-center uppercase font-semibold"
              >
                Clinical trials
              </h2>
              <p class="fsize13 mt-2 text-center">
                Patients who participate in clinical trials may have access to
                free or low-cost cancer treatment.
              </p>
            </div>

            <div class="cust-option-sections">
              <h2
                class="fsize16 text4F0A4B text-center uppercase font-semibold"
              >
                Hospital financial assistance programs
              </h2>
              <p class="fsize13 mt-2 text-center">
                Many hospitals have financial assistance programs that can help
                cover the cost of cancer treatment for patients who meet certain
                eligibility criteria.
              </p>
            </div>
            <div class="cust-option-sections">
              <h2
                class="fsize16 text4F0A4B text-center uppercase font-semibold"
              >
                Health insurance
              </h2>
              <p class="fsize13 mt-2 text-center">
                If the patient has health insurance, it's essential to
                understand what the policy covers and what out-of-pocket costs
                the patient may incur. Work with the insurance company to
                understand the patient's benefits and coverage.
              </p>
            </div>
            <div class="cust-option-sections">
              <h2
                class="fsize16 text4F0A4B text-center uppercase font-semibold"
              >
                Government assistance programs
              </h2>
              <p class="fsize13 mt-2 text-center">
                The government provides several assistance programs for cancer
                patients, such as Medicaid, Medicare, and the Social Security
                Disability Insurance (SSDI). These programs can help cover the
                cost of treatment and other expenses. 
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="w-1/6 border-left py-4 pl-4">
        <div class="border-bottom">
          <h2 class="fsize16 font-semibold pb-1">Our Latest Blogs</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            5 Essential Tips for Balancing Caregiving and Self-Care
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Navigating the Emotional Challenges of Being a...
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            How to Create a Support Network for Caregivers
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Understanding the Legal Rights of Family Caregivers
          </p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">
            10 Signs of Caregiver Burnout and How to Avoid It
          </p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">Latest Research</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            The Mental Health Impact of Caregiving on Family Members
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Emerging Trends in Palliative Care: What Caregivers Need ..
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            he Science Behind Compassion Fatigue: What...
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Latest Research on the Emotional Toll of End-of-Life..
          </p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">
            Emerging Trends in Palliative Care: What Caregivers...
          </p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">Explore Resources</h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Emotional First Aid</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Caregiver Coach Program</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Mental health Awareness</p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">Medical Terminology</p>
          <p class="fsize13 lh16px pb-3 clr-0087d4">Caring at Caregiver sath</p>
        </div>
        <div class="border-bottom py-3">
          <h2 class="fsize16 font-semibold pb-1">
            Helpful Links and Collaborations
          </h2>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            Duis volutpat pulvinar nisi
          </p>
          <p class="fsize13 lh16px pb-2 clr-0087d4">
            et rutrum nisl rhoncus nec
          </p>
        </div>
      </div>/// -->
      <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
        <SideBlogs />
      </div> -->
    </div>
  </div>
</template>
<script>
import SideBlogs from "./components/SideBlogs.vue";

export default {
  components: {
    SideBlogs,
  },
};
</script>
<style>
.cust-option-sections {
  border: 0.41px solid #000000;
  padding: 20px 12px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.section_img1 {
  height: 350px;
  width: 100%;
  border-radius: 18px;
}
</style>
